import React, { useState } from 'react';
import Data from '../constants.json';
import Certificate from './certificates';
import Revocation from './revocations';
const { certificationsNavItem } = { ...Data };

const CertificationManagement = () => {
  const [activeTab, setActiveTab] = useState(1);

  const handleClickSelect = (id) => {
    setActiveTab(id);
  }

  return (
    <>
      <div className='containerSubNavCss'>
        {certificationsNavItem.map(({ name, id }) => {
          return (
            <a key={id} data-testid={`nav-${name}`} onClick={() => handleClickSelect(id)} className={activeTab === id ? 'active' : ''} >{`${name}`}</a>
          );
        })}
      </div>
      <div className='componentContainer'>
        {
          activeTab === 1 ?
          <Certificate/> : <Revocation/>
        }
      </div>
    </>
  );
};
export default CertificationManagement;

